export default "__VITE_ASSET__8027f486__"